import DataStore from 'flux/stores/DataStore.js'
import FacebookProvider, { Page } from 'react-facebook'
import ReactGA from 'react-ga';


class About extends React.Component {
  constructor () {
    super()
    ReactGA.pageview(window.location.pathname + window.location.search);

    const languages = DataStore.getAllLanguages()

    const split = window.location.pathname.split('/')

    let lang = 'sv'
    if (languages.includes(split[1])) {
      lang = split[1]
    }

    let pageData = DataStore.getPageBySlug(split[split.length - 1], lang);

    const template = pageData.template.replace('.php', '') 
    this.state = {
      template: template,
      lang: lang,
      headerImage: pageData.acf.headerImage ? pageData.acf.headerImage.sizes.header : undefined,
      title: pageData.acf.title ? pageData.acf.title : pageData.title.rendered,
      content: pageData.acf.contentRepeater,
      otherContent: pageData.acf.otherContent,
    }
  }

  render() {

    return (
      <div className={`page page--${this.state.template}`}>
        <div className="page__header page__header--noimg">
          <h1 className="page__header__title">{this.state.title }</h1>
        </div>

        {/* <FacebookProvider appId="121504208724846">
          <Page href="https://www.facebook.com/anderssons.ax" tabs="timeline"/>
        </FacebookProvider>   */}


        <div className="page__content">

          {this.state.content &&
            this.state.content.map((item, index) => <PageContent key={`content` + index} wysiwyg={item.wysiwyg} image={item.image} />)
          }
        </div>

        {this.state.otherContent &&
          this.state.otherContent.map((item) => <FeaturedBlock key="column1" item={item} />)
        }
      </div>
    );
  }
}

class PageContent extends React.Component {
  render() {
    return (
      <div className="page__content__item">
        <div className="page__content__item__text">
          <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: this.props.wysiwyg }} />
        </div>

        {this.props.image &&
          <div className="page__content__item__image">
            <img src={this.props.image.sizes.square} />
          </div>
        }
      </div>
    )
  }
}

class FeaturedBlock extends React.Component {
  render() {

    return (
      <div className="page__box">
        <div className="page__box__content">
          <div className="wysiwyg">
            <h3>{this.props.item.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.item.wywiwyg }} />
          </div>
          {this.props.item.image &&
            <div className="page__box__image">
              <img src={this.props.item.image.sizes.medium} />
            </div>
          }

        </div>
      </div>
    )
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/scripts/components/About.js